import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "prev", "next"]
  static values = {
    step: { type: Number, default: 0.85 }
  }

  connect() {
    this._updateControls = this.updateControls.bind(this)
    this._onTrackScroll = this.onTrackScroll.bind(this)

    this.trackTarget.addEventListener("scroll", this._onTrackScroll, { passive: true })
    window.addEventListener("resize", this._updateControls)

    if ("ResizeObserver" in window) {
      this._resizeObserver = new ResizeObserver(this._updateControls)
      this._resizeObserver.observe(this.trackTarget)
    }

    requestAnimationFrame(this._updateControls)
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this._onTrackScroll)
    window.removeEventListener("resize", this._updateControls)
    this._resizeObserver?.disconnect()
  }

  scrollPrev(event) {
    event?.preventDefault()
    this.scrollByOffset(-1)
  }

  scrollNext(event) {
    event?.preventDefault()
    this.scrollByOffset(1)
  }

  onTrackScroll() {
    if (this._scrollRaf) return
    this._scrollRaf = requestAnimationFrame(() => {
      this._scrollRaf = null
      this.updateControls()
    })
  }

  updateControls() {
    const track = this.trackTarget
    const maxScroll = track.scrollWidth - track.clientWidth
    const hasOverflow = maxScroll > 1

    this.element.classList.toggle("landing-offer-carousel--scrollable", hasOverflow)

    if (!hasOverflow) {
      this.togglePrev(false)
      this.toggleNext(false)
      this.element.classList.remove("landing-offer-carousel--can-prev", "landing-offer-carousel--can-next")
      return
    }

    const position = track.scrollLeft
    const canPrev = position > 1
    const canNext = position < maxScroll - 1

    this.togglePrev(canPrev)
    this.toggleNext(canNext)
    this.element.classList.toggle("landing-offer-carousel--can-prev", canPrev)
    this.element.classList.toggle("landing-offer-carousel--can-next", canNext)
  }

  scrollByOffset(direction) {
    const track = this.trackTarget
    const distance = Math.max(track.clientWidth * this.stepValue, 240) * direction
    track.scrollBy({ left: distance, behavior: "smooth" })
  }

  togglePrev(enabled) {
    if (!this.hasPrevTarget) return
    this.prevTarget.hidden = !enabled
    this.prevTarget.setAttribute("aria-hidden", enabled ? "false" : "true")
    this.prevTarget.disabled = !enabled
  }

  toggleNext(enabled) {
    if (!this.hasNextTarget) return
    this.nextTarget.hidden = !enabled
    this.nextTarget.setAttribute("aria-hidden", enabled ? "false" : "true")
    this.nextTarget.disabled = !enabled
  }
}
